import { render, staticRenderFns } from "./Free.vue?vue&type=template&id=ac307c70&scoped=true"
import script from "./Free.vue?vue&type=script&lang=js"
export * from "./Free.vue?vue&type=script&lang=js"
import style0 from "./Free.vue?vue&type=style&index=0&id=ac307c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac307c70",
  null
  
)

export default component.exports